import { Injectable } from '@angular/core';
import { Cargo } from '../interfaces/cargo';
import { ServiceMessages } from '../messages/service-messages.enum';
import { resolveCargosTransportNit } from '../resources/transport-company-context.utils';
import { SnackBarService } from './snackBar.service';

/**
 * Barrera estándar para operaciones sobre varios servicios (pagos, facturación,
 * comprobantes): no deben mezclar empresas de transporte, aunque la pastilla del
 * listado ya las acote. Centraliza la regla (resolveCargosTransportNit) y el aviso.
 */
@Injectable({ providedIn: 'root' })
export class TransportCompanyGuardService {

  constructor(private snackBarService: SnackBarService) { }

  /**
   * true si se puede continuar; false si se mezclan empresas o, con
   * expectedTransportCompanyId (la empresa elegida en el listado), si los
   * servicios son de otra. Los servicios sin empresa (previos a la división)
   * no bloquean. Cuando devuelve false ya avisó al usuario.
   */
  ensureSameTransportCompany(cargos: Cargo[], expectedTransportCompanyId?: string): boolean {
    const resolved = resolveCargosTransportNit(cargos);
    if (!resolved.consistent) {
      this.snackBarService.openSnackBar(ServiceMessages.CARGOS_DIFFERENT_TRANSPORT_COMPANY, undefined, 'alert');
      return false;
    }
    if (expectedTransportCompanyId && resolved.transportNit && resolved.transportNit !== expectedTransportCompanyId) {
      this.snackBarService.openSnackBar(ServiceMessages.CARGOS_NOT_FROM_SELECTED_TRANSPORT_COMPANY, undefined, 'alert');
      return false;
    }
    return true;
  }
}
